<div class="modal-header">
    <h5 class="modal-title" id="editAddressTitle">{{headerText}}</h5>
    <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
    <form [formGroup]="manageLocationForm">
        <div class="row gx-3">
            <div class="row gx-3">
                <div class="col-12 mb-3">
                    <label for="address1" class="form-label">Address Name<sup class="text-danger">*</sup></label>
                    <input formControlName="locationName" type="text" class="form-control" id="name" placeholder="Name" required>
                    <div *ngIf="locationNameCtrl.invalid && (locationNameCtrl.dirty || locationNameCtrl.touched)" class="invalid-feedback">
                        <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="address3" class="form-label">Address Phone<sup class="text-danger">*</sup></label>
                <input formControlName="phoneNumber" type="text"  mask="(000) 000-0000" class="form-control" id="address3" placeholder="Phone Number" required>
                <div *ngIf="phoneNumberCtrl.invalid && (phoneNumberCtrl.dirty || phoneNumberCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="address4" class="form-label">Location Email</label>
                <input formControlName="emailAddress" type="text" class="form-control" id="email" placeholder="Email Address">
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-12 mb-3">
                <label for="address1" class="form-label">Address<sup class="text-danger">*</sup></label>
                <input formControlName="street" type="text" class="form-control" id="address1" placeholder="Address" required>
                <div *ngIf="streetCtrl.invalid && (streetCtrl.dirty || streetCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-8 mb-3">
                <label for="address3" class="form-label">City<sup class="text-danger">*</sup></label>
                <input formControlName="city" type="text" class="form-control" id="address3" placeholder="City" required>
                <div *ngIf="cityCtrl.invalid && (cityCtrl.dirty || cityCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <label for="address4" class="form-label">ZIP<sup class="text-danger">*</sup></label>
                <input formControlName="zip" type="text" class="form-control" id="address4" placeholder="Zip" required>
                <div *ngIf="zipCtrl.invalid && (zipCtrl.dirty || zipCtrl.touched)" class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-12 mb-3">
                <label for="address5" class="form-label">Address Notes</label>
                <input formControlName="notes" type="text" class="form-control" id="address5" placeholder="Notes">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" (click)="saveAddress()" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100"
        data-bs-dismiss="modal">Cancel</button>
</div>